'use strict';

/**
 * 通过语言包 key 获取文案
 * @param  {String} localeKey   语言包 key 值
 * @return {String}             不存在则返回 undefined
 */

module.exports = function (localeKey) {
  if (typeof window === 'undefined') return;
  if (!window.__intl__ || !window.__intl__.messages) return;

  var intl = window.__intl__.messages;
  var value = getObj(intl, localeKey);

  if (!value) return localeKey;
  return value;
};

/**
 * getObj 通过 key string 说去对象的属性值
 * @private
 * @param  {Object} obj         对象
 * @param  {String} [keyStr=''] key string
 * @return {String}             不存在则返回 undefined
 */
function getObj(obj) {
  var keyStr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var ARRAY_PATH_REGEXP = /\[\s*(\d+)\s*\]/;
  var keyArr = keyStr.split('.');
  for (var i = 0; i < keyArr.length; i++) {
    var key = keyArr[i];
    if (!obj) {
      return;
    }
    var matchArrayPath = key.match(ARRAY_PATH_REGEXP);
    if (matchArrayPath && matchArrayPath[1]) {
      obj = obj[key.replace(ARRAY_PATH_REGEXP, '')][matchArrayPath[1]];
    } else {
      obj = obj[key];
    }
  }
  return obj;
}